import { useUserContext } from "lib/state/UserContextProvider";
import type { ReactNode } from "react";
import Loading from "ui/components/Loading";
import type { BuilderHeaderProps } from "./BuilderHeader";
import BuilderHeader from "./BuilderHeader";
import BuilderPortalLayoutFrame from "./BuilderPortalLayoutFrame";
import BuilderPortalSideNav, { type BuilderPortalPage } from "./BuilderPortalSideNav";
import BuilderPortalTopNav from "./BuilderPortalTopNav";

interface BuilderPortalLayoutProps extends BuilderHeaderProps {
  selected?: BuilderPortalPage;
  children: ReactNode;
  pageTitle: string;
  className?: string;
  betaProduct?: boolean;
  wide?: boolean;
  loadingContent?: boolean;
}

export default function BuilderPortalLayout({
  selected,
  children,
  pageTitle,
  breadcrumbs,
  header,
  subheaderItems,
  menuItems,
  headerActions,
  className,
  betaProduct,
  wide,
  loadingContent,
  featureStatus,
}: BuilderPortalLayoutProps) {
  const { user } = useUserContext();

  const content = (
    <>
      {user && header && (
        <BuilderHeader
          wide={wide}
          betaProduct={betaProduct}
          featureStatus={featureStatus}
          breadcrumbs={breadcrumbs}
          header={header}
          subheaderItems={subheaderItems}
          menuItems={menuItems}
          headerActions={headerActions}
        />
      )}
      {loadingContent ? <Loading /> : children}
    </>
  );

  return (
    <BuilderPortalLayoutFrame
      pageTitle={pageTitle}
      className={className}
      topNav={<BuilderPortalTopNav />}
      sideNav={<BuilderPortalSideNav selected={selected} />}
    >
      {content}
    </BuilderPortalLayoutFrame>
  );
}
